export default __webpack_public_path__ + "static/media/Who we serve1.6ee30e45.jpeg";